import { type Release } from '../models';
import RecordFilter from './RecordFilter';

class ReleaseFilter extends RecordFilter {
  matches(record: { release: Release }) {
    return super.matches(record.release);
  }
}

export default ReleaseFilter;
